'use strict';

var _slicedToArray = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _getPrototypeOf = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _classCallCheck = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var Util = require('util');

var Hoek = require('@hapi/hoek');

var Any = require('../any');

var internals = {};

internals.Map = /*#__PURE__*/function (_Map) {
  _inherits(_class, _Map);

  var _super = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super.apply(this, arguments);
  }

  _createClass(_class, [{
    key: "slice",
    value: function slice() {
      return new internals.Map(this);
    }
  }, {
    key: "toString",
    value: function toString() {
      return Util.inspect(this);
    }
  }]);

  return _class;
}( /*#__PURE__*/_wrapNativeSuper(Map));

internals.Symbol = /*#__PURE__*/function (_Any) {
  _inherits(_class2, _Any);

  var _super2 = _createSuper(_class2);

  function _class2() {
    var _this;

    _classCallCheck(this, _class2);

    _this = _super2.call(this);
    _this._type = 'symbol';
    _this._inner.map = new internals.Map();
    return _this;
  }

  _createClass(_class2, [{
    key: "_base",
    value: function _base(value, state, options) {
      if (options.convert) {
        var lookup = this._inner.map.get(value);

        if (lookup) {
          value = lookup;
        }

        if (this._flags.allowOnly) {
          return {
            value: value,
            errors: typeof value === 'symbol' ? null : this.createError('symbol.map', {
              value: value,
              map: this._inner.map
            }, state, options)
          };
        }
      }

      return {
        value: value,
        errors: typeof value === 'symbol' ? null : this.createError('symbol.base', {
          value: value
        }, state, options)
      };
    }
  }, {
    key: "map",
    value: function map(iterable) {
      if (iterable && !iterable[Symbol.iterator] && typeof iterable === 'object') {
        iterable = Object.entries(iterable);
      }

      Hoek.assert(iterable && iterable[Symbol.iterator], 'Iterable must be an iterable or object');
      var obj = this.clone();
      var symbols = [];

      var _iterator = _createForOfIteratorHelper(iterable),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          Hoek.assert(entry && entry[Symbol.iterator], 'Entry must be an iterable');

          var _entry = _slicedToArray(entry, 2),
              key = _entry[0],
              value = _entry[1];

          Hoek.assert(typeof key !== 'object' && typeof key !== 'function' && typeof key !== 'symbol', 'Key must not be an object, function, or Symbol');
          Hoek.assert(typeof value === 'symbol', 'Value must be a Symbol');

          obj._inner.map.set(key, value);

          symbols.push(value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return obj.valid.apply(obj, symbols);
    }
  }, {
    key: "describe",
    value: function describe() {
      var description = _get(_getPrototypeOf(_class2.prototype), "describe", this).call(this);

      description.map = new Map(this._inner.map);
      return description;
    }
  }]);

  return _class2;
}(Any);

module.exports = new internals.Symbol();